import { MedicalImagesGroups } from '../config/medicalImages.types';

export const isMedicalImagesTitle = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  title: any,
): title is MedicalImagesGroups =>
  Object.values(MedicalImagesGroups).includes(title);
